"use strict";
(self["webpackChunklilacst"] = self["webpackChunklilacst"] || []).push([[5491],{

/***/ 5491:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ productCardForm)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function productCardForm({ wrapper }) {
  if (wrapper.componentInitialized) return
  wrapper.componentInitialized = true

  const selectors = {
    atcButton: '[data-hook="atc-btn"]',
    card: '[data-hook="product-card"]',
    images: '[data-component="product/images"]',
    featuredImage: '[data-hook="featured-image"]',
  }

  const cache = {
    $atcButton: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.atcButton),
    $card: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).closest(selectors.card),
    $images: wrapper.closest(selectors.card).querySelector(selectors.images),
    $featuredImage: wrapper.closest(selectors.card).querySelector(selectors.featuredImage),
  }

  const { classes } = config

  let windowWidth = window.innerWidth

  ;(function init() {
    checkOptions()

    cache.$atcButton.on('click.productCardForm', handleCTA)

    if (showOptions()) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('product-card:reset', function (event) {
        if (!jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.target).is(wrapper)) {
          resetState()
        }
      })

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('resize', function () {
        if (window.innerWidth == windowWidth) return
        windowWidth = window.innerWidth

        resetState()
      })
    }
  })()

  function checkOptions() {
    if (cache.$atcButton[0].hasAttribute('data-toggle')) {
      selectors.options = cache.$atcButton.data('toggle')
      cache.$options = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.options)
    }
  }

  function showOptions() {
    const atcIsToggleable = cache.$atcButton[0].hasAttribute('data-toggle')
    const atcIsInactive = !cache.$atcButton.hasClass(classes.active)

    return atcIsToggleable && atcIsInactive
  }

  function handleCTA(event) {
    if (showOptions()) {
      event.preventDefault()

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).trigger('product-card:reset')

      setTimeout(() => {
        revealOptions()
      }, 100)
    }
  }

  function revealOptions() {
    // 2. Update state for the options selector & ATC button
    cache.$options.addClass(classes.active)
    cache.$atcButton.addClass(classes.active)

    // 3. Update button text
    const oldButtonText = cache.$atcButton.text().trim()
    const newButtonText = cache.$atcButton.data('label').trim()

    cache.$atcButton.text(newButtonText)
    cache.$atcButton.data('label', oldButtonText)

    // 4. Update button [type]
    cache.$atcButton.prop('type', 'submit')

    // 5. Dispatch an event to update the button state
    const revealOptionsEvent = new CustomEvent('product:reveal-options', {
      bubbles: true, // Enable bubbling to listen on the document/window etc.
      detail: { wrapper },
    })
    wrapper.dispatchEvent(revealOptionsEvent)

    // 6. Emit the current variant
    wrapper.emitCurrentVariant()
  }

  function resetState() {
    if (showOptions()) return

    // Reset state for the options selector & ATC button
    cache.$options.removeClass(classes.active)
    cache.$atcButton.removeClass(classes.active)

    // Update button text
    const oldButtonText = cache.$atcButton.text().trim()
    const newButtonText = cache.$atcButton.data('label').trim()
    cache.$atcButton.text(newButtonText)
    cache.$atcButton.data('label', oldButtonText)

    // Update button [type]
    cache.$atcButton.prop('type', 'button')

    // Update Image
    const newImageUrl = cache.$featuredImage.getAttribute('data-url')
    cache.$images.updateVariantImage(newImageUrl)
  }
}


/***/ })

}]);